import { incidentTypeNames } from 'src/api/types';
import { formatDate, sanitizeForCSV } from 'src/utils/misc';
import Papa from 'papaparse';
import { IncidentCsvHeaders } from 'src/api/types/misc';
import { IncidentsQuery } from 'src/graphql/_generated';

export const downloadCsv = (data: IncidentsQuery['incidents']) => {
  const rows = [
    [
      IncidentCsvHeaders.ID,
      IncidentCsvHeaders.RefID,
      IncidentCsvHeaders.Name,
      IncidentCsvHeaders.Description,
      IncidentCsvHeaders.Source,
      IncidentCsvHeaders.Date,
      IncidentCsvHeaders.Owner,
      IncidentCsvHeaders.Impact,
      IncidentCsvHeaders.FinancialImpactUpper,
      IncidentCsvHeaders.FinancialImpactLower,
      IncidentCsvHeaders.Type,
      IncidentCsvHeaders.Severity,
    ],
    ...data.map((el) => {
      const type = el.incidentType ? incidentTypeNames[el.incidentType as keyof typeof incidentTypeNames] : '';
      return [
        sanitizeForCSV(el.id),
        sanitizeForCSV(el.ref),
        sanitizeForCSV(el.name),
        sanitizeForCSV(el.description),
        sanitizeForCSV(el.source),
        formatDate(el.dateOfIncident),
        sanitizeForCSV(el.owner?.text),
        sanitizeForCSV(el.impact),
        sanitizeForCSV(el.financialImpactLower),
        sanitizeForCSV(el.financialImpactUpper),
        sanitizeForCSV(type),
        sanitizeForCSV(el.severity),
      ];
    }),
  ];
  const csvString = Papa.unparse(rows);
  const anchor = document.createElement('a');
  anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csvString);
  anchor.target = '_blank';
  anchor.download = `Security Incidents.csv`;
  anchor.click();
};
